/* eslint-disable camelcase */
import {
  useState, useMemo, HTMLProps, useEffect,
} from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import { useScreenClass } from 'react-grid-system';
import { ErrorMessage } from '@hookform/error-message';
import FlexBox, { FlexGrow } from './FlexBox';
import theme from '../styles/theme';
import { StyledText } from './Text';
import Button from './Button';
import { RightAlign } from './UtilsComponents';
import Icon, { ClickableIcon } from './Icon';
import Status from '../types/enum/Status';
import Modal from './Modal';
import Input from './Input';

const TextArea = styled.textarea`
  width: 100%;
  padding: 8px 4px;
  min-height: 100px;
}
`;
type AnnouncementForm = {
  announcement: string;
};
type Document = {
  announcement: string;
  id: string;
};

type EditAnnouncementProps = {
  isOpen?: boolean;
  setOpen?: (x: boolean) => void;
  onEditComplete?: () => void;
  info: Document;
  mode: 'edit' | 'create';
};

const EditAnnouncement = ({
  isOpen,
  setOpen,
  onEditComplete,
  info,
  mode,
}: EditAnnouncementProps): JSX.Element => {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    formState: { errors, isDirty },
  } = useForm<AnnouncementForm>({
    mode: 'onChange',
    defaultValues: {
      announcement: info.announcement,
    },
  });
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ['xs', 'sm'].includes(screenClass),
    [screenClass],
  );
  const [loading, setLoading] = useState<boolean>(false);
  const watchAllFields = watch();
  const onSubmitClicked = (data: any) => {
    setLoading(true);
    if (mode === 'create') {
      axios
        .post('/api/v1/announcement', data)
        .then((res) => {
          setLoading(false);
          setOpen?.(false);
          onEditComplete?.();
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
    if (mode === 'edit') {
      axios
        .put(`api/v1/announcement/${info.id}`, data)
        .then((res) => {
          setLoading(false);
          onEditComplete?.();
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
  };
  useEffect(() => {
    reset();
  }, [isOpen]);
  const onError = (errors: any, e: any) => console.log('error', errors, e);
  return (
    <>
      <Modal isOpen={!!isOpen} setOpen={setOpen}>
        <FlexBox
          style={{
            marginBottom: theme.spacing.base * 3,
          }}>
          <FlexGrow>
            <h3
              style={{
                marginRight: 'auto',
                marginBottom: 0,
                textTransform: 'capitalize',
              }}>
              {mode} Announcement
            </h3>
          </FlexGrow>
          <RightAlign>
            <ClickableIcon name="x-s" onClick={() => setOpen?.(false)} />
          </RightAlign>
        </FlexBox>
        {!loading ? (
          <form onSubmit={handleSubmit(onSubmitClicked, onError)}>
            <FlexBox
              alignItems="flex-start"
              style={{
                marginBottom: theme.spacing.x2,
              }}>
              <FlexGrow grow={1}>Title</FlexGrow>
              <FlexGrow grow={3}>
                <Input
                  isFullWidth
                  {...register('announcement', { required: true })}
                />
                <ErrorMessage
                  errors={errors}
                  name="announcement"
                  render={({ message }) => (
                    <p
                      style={{
                        marginTop: 0,
                        color: theme.color.danger,
                      }}>
                      Announcement title is required!
                    </p>
                  )}
                />
              </FlexGrow>
            </FlexBox>
            <FlexBox
              alignItems="center"
              justify="flex-end"
              style={{
                marginTop: theme.spacing.x4,
                marginBottom: theme.spacing.x2,
              }}>
              <FlexGrow>
                <RightAlign>
                  <Button
                    onClick={() => {
                      setOpen?.(false);
                    }}
                    isOutline
                    status={Status.primary}
                    style={{ padding: '4px 12px' }}>
                    <Icon name="x-s" mr={0.5} />
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    // disabled={!isDirty}
                    onClick={() => handleSubmit(onSubmitClicked)}
                    status={Status.primary}
                    backgroundColor="#CB092B"
                    style={{ padding: '4px 12px', marginLeft: '8px' }}>
                    <Icon name="floppy" mr={0.5} />
                    Save
                  </Button>
                </RightAlign>
              </FlexGrow>
            </FlexBox>
          </form>
        ) : (
          <Icon mr={1} name="spinner" spin />
        )}
      </Modal>
    </>
  );
};

export default EditAnnouncement;
